<template>
  <b-card class="service-card mb-1 p-2" no-body>

    <!-- Accommodation name + localizator -->
    <div class="d-flex justify-content-between align-items-center px-1 pt-1 pb-75">
      <router-link v-if="booking.accommodationSlug"
        :to="{ name: 'foravila-accommodation-view', params: { slug: booking.accommodationSlug } }"
        class="font-weight-bold text-truncate mr-1">{{ booking.accommodation }}</router-link>
      <span v-else class="font-weight-bold text-truncate mr-1">{{ booking.accommodation }}</span>
      <b-badge variant="light-secondary" class="text-nowrap flex-shrink-0">
        {{ booking.localizator }}
      </b-badge>
    </div>

    <hr class="my-0" />

    <!-- Details -->
    <div class="px-1 pt-75 pb-1">
      <!-- Dates -->
      <div class="d-flex align-items-center mb-50">
        <feather-icon icon="CalendarIcon" size="13" class="text-primary mr-75 flex-shrink-0" />
        <span class="small">
          {{ formatBookingDate(booking.checkin) }}
          <feather-icon icon="ArrowRightIcon" size="10" class="mx-25 text-muted" />
          {{ formatBookingDate(booking.checkout) }}
        </span>
      </div>
      <!-- Time -->
      <div class="d-flex align-items-center mb-75">
        <feather-icon icon="ClockIcon" size="13" class="text-primary mr-75 flex-shrink-0" />
        <span class="small">{{ $t("Entrada") }}: <strong>{{ booking.checkinTime }}</strong></span>
      </div>
      <!-- Badges row -->
      <div class="d-flex flex-wrap" style="gap: 0.35rem;">
        <b-badge pill variant="light-secondary">
          <feather-icon icon="UsersIcon" size="11" class="mr-25" />
          {{ booking.guests }}
        </b-badge>
        <b-badge pill :variant="booking.babyCots ? 'light-primary' : 'light-secondary'">
          🚼 {{ booking.babyCotsText }}
        </b-badge>
        <b-badge pill :variant="booking.babyChairs ? 'light-primary' : 'light-secondary'">
          🪑 {{ booking.babyChairsText }}
        </b-badge>
        <b-badge pill :variant="bedLinenChangeDates.length ? 'light-warning' : 'light-secondary'">
          🛏 {{ bedLinenChangeDates.length ? bedLinenChangeDates.join(' · ') : $t('No') }}
        </b-badge>
      </div>

      <!-- Cleaning status button -->
      <div class="mt-4">
        <b-button block size="sm" :variant="booking.cleaningCompleted ? 'success' : 'outline-secondary'"
          @click="$emit('toggle-cleaning', booking)">
          <feather-icon :icon="booking.cleaningCompleted ? 'CheckCircleIcon' : 'CircleIcon'" size="14" class="mr-25" />
          {{ booking.cleaningCompleted ? $t('Neteja completada') : $t('Marcar com a netejat') }}
        </b-button>
      </div>
    </div>

  </b-card>
</template>

<script>
import { BCard, BBadge, BButton } from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import { formatDateObjectToDate } from "@formatters";

export default {
  components: {
    BCard, BBadge, BButton, FeatherIcon,
  },
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    bedLinenChangeDates() {
      return (this.booking.bedLinenChange || []).map((d) =>
        formatDateObjectToDate(d, this.$i18n.locale, { month: "2-digit", day: "2-digit" })
      );
    },
  },
  methods: {
    formatBookingDate(date) {
      return formatDateObjectToDate(date, this.$i18n.locale);
    },
  },
};
</script>
